var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":_vm.$g('logout')}},[_c('b-icon',{attrs:{"icon":"power"},on:{"click":_vm.onLogout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }